import { DateSelectorType } from './enums';
import { Dispatch, SetStateAction } from 'react';
import { clearDateSelector } from './logic/clearDateSelector';

/**
 * Returns a function that resets the date picker's editor data to the current state of the
 * date picker.
 */
export const useDateSelectorItemClearFunction =
  (
    startDate: Date | undefined,
    setStartDate: Dispatch<SetStateAction<Date | undefined>>,
    startType: DateSelectorType | undefined,
    setStartType: Dispatch<SetStateAction<DateSelectorType | undefined>>,
    endDate: Date | undefined,
    setEndDate: Dispatch<SetStateAction<Date | undefined>>,
    endType: DateSelectorType | undefined,
    setEndType: Dispatch<SetStateAction<DateSelectorType | undefined>>
  ) =>
  () => {
    //TODO: We should probably actually hold this value when the user starts changing it
    //rather than this bandaid.
    //If the saved type is 'today' but the incoming date isn't today, reset it
    clearDateSelector(startDate, setStartDate, startType, setStartType);
    clearDateSelector(endDate, setEndDate, endType, setEndType);
  };
